import moment from "moment";

const TIME_PARSE_FORMATS = ["HH:mm:ss", "HH:mm", "h:mm A", "hh:mm A"];

/** Normalize API / DB times to HH:mm for HTML type="time" inputs. */
export function normalizeTimeForInput(
  time: string | null | undefined
): string {
  if (!time || !String(time).trim()) return "";
  const parsed = moment(time, TIME_PARSE_FORMATS, true);
  return parsed.isValid() ? parsed.format("HH:mm") : "";
}

/** Normalize to HH:mm:ss for API storage. */
export function normalizeTimeForStorage(
  time: string | null | undefined
): string {
  if (!time || !String(time).trim()) return "";
  const parsed = moment(time, TIME_PARSE_FORMATS, true);
  return parsed.isValid() ? parsed.format("HH:mm:ss") : String(time);
}

/** Max course hours per day from school working time span (rounded up). */
export function computeSchoolWorkingHoursMax(
  settingsRow: { working_time_from?: string; working_time_to?: string } | null | undefined
): number {
  if (!settingsRow?.working_time_from || !settingsRow?.working_time_to) {
    return 8;
  }
  const start = moment(settingsRow.working_time_from, TIME_PARSE_FORMATS, true);
  const end = moment(settingsRow.working_time_to, TIME_PARSE_FORMATS, true);
  if (!start.isValid() || !end.isValid()) {
    return 8;
  }
  const minutes = end.diff(start, "minutes");
  if (minutes <= 0) {
    return 8;
  }
  return Math.ceil(minutes / 60);
}
